import { SETCOMBINLIST, SETTOKEN, SETNAME, PURCHASEINIT, STEPCOMPLETE, SETSELECTDATA, GETPDF, LOGOUT, SETERRORMSG, EXPERTINDO, FAQLOAD, FOOTER, CLEAN, GETTSRINFO, SETTSRFUND, SAVECOMBINITEM, CLEANCOMBINITEM } from '../action/anueInfoAction';

const CUSTINIT = {
    CombinList: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    isLogin: "N",
    custName: "",
    acctT: undefined,
    acctF: undefined,
    allFundList: undefined,
    prevFundList: undefined,
    altMinAmt: undefined,
    chkIsFirst: undefined,
    rspDay: undefined,
    rspMinAmt: undefined,
    completeData: undefined,
    expertInfo: [],
    FAQInfo: [],
    FooterInfo: "",
    TSRDataInfo: undefined,
    //selectData
    selectGdName: "",
    selectAccount: {},
    selectContext: "",
    selectInvDay: {},
    selectPromText: "",
    selectPDF: undefined,
    selectTsrFund: undefined,
    //單號
    tradeNo: "",
    //暫存投組資料
    combinItem: undefined
};

export default function (state = CUSTINIT, action) {
    switch (action.type) {
        case SETCOMBINLIST:
            return { ...state, CombinList: action.payload };
        case SETTOKEN:
            return { ...state, accessToken: action.payload.accessToken, refreshToken: action.payload.refreshToken, isLogin: "Y" };
        case SETNAME:
            return { ...state, custName: action.payload.custName };
        case PURCHASEINIT:
            let acctT, acctF;
            for (let i = 0; i <= action.payload.acct.length - 1; i++) {
                if (action.payload.acct[i].isChoose === "Y") {
                    if (action.payload.acct[i].accType === "T") {
                        acctT = action.payload.acct[i];
                    } else {
                        acctF = action.payload.acct[i];
                    }
                }
            }
            return { ...state, ...action.payload, acctT: acctT, acctF: acctF };
        case STEPCOMPLETE:
            return { ...state, completeData: action.payload };
        case SETSELECTDATA:
            return { ...state, ...action.payload };
        case GETPDF:
            return { ...state, selectPDF: action.payload };
        case LOGOUT:
            return { ...state, isLogin: "N", accessToken: undefined, refreshToken: undefined, custName: undefined, acctT: undefined, acctF: undefined, allFundList: undefined, prevFundList: undefined, altMinAmt: undefined, chkIsFirst: undefined, rspDay: undefined, rspMinAmt: undefined, completeData: undefined, selectGdName: "", selectAccount: {}, selectContext: "", selectInvDay: 0, selectPromText: "", selectPDF: [] }
        case CLEAN:
            return { ...state, acctT: undefined, acctF: undefined, allFundList: undefined, prevFundList: undefined, altMinAmt: undefined, chkIsFirst: undefined, rspDay: undefined, rspMinAmt: undefined, completeData: undefined, selectGdName: "", selectAccount: {}, selectContext: "", selectInvDay: 0, selectPromText: "", selectPDF: [], selectTsrFund: undefined, TSRDataInfo: undefined, selectNextDay: "" }
        case SETERRORMSG:
            return { ...state, errorMsg: action.payload };
        case EXPERTINDO:
            return { ...state, expertInfo: action.payload };
        case FAQLOAD:
            return { ...state, FAQInfo: action.payload };
        case FOOTER:
                return { ...state, FooterInfo: action.payload };
        case GETTSRINFO:
            return { ...state, TSRDataInfo: action.payload };
        case SETTSRFUND:
            return { ...state, selectTsrFund: action.payload };
        case SAVECOMBINITEM:
            return { ...state, combinItem: action.payload };
        case CLEANCOMBINITEM:
            return { ...state, combinItem: undefined };
        default:
            return state;
    }
}